// @flow strict
import * as React from 'react';

type Props = {
  active: boolean,
  children?: React.Node,
  // eslint-disable-next-line no-undef
  onClickOutside: (e: MouseEvent) => mixed,
};

export default (
  activeClass: string,
  inactiveClass: string
): React.AbstractComponent<Props> => {
  const ClickCatcher = ({ active, children, onClickOutside }: Props) => {
    return (
      <div
        className={active ? activeClass : inactiveClass}
        onClick={onClickOutside}
      >
        {children}
      </div>
    );
  };
  return ClickCatcher;
};
